import * as React from "react";
const SvgSetting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.25}
      clipPath="url(#setting_svg__a)"
    >
      <path d="M11.995 14.699a2.699 2.699 0 1 0 0-5.397 2.699 2.699 0 0 0 0 5.397" />
      <path d="M3 12.792v-1.583c0-.936.765-1.71 1.71-1.71 1.627 0 2.293-1.151 1.474-2.563a1.71 1.71 0 0 1 .63-2.33l1.556-.89c.711-.424 1.629-.172 2.051.539l.1.17c.809 1.413 2.14 1.413 2.959 0l.099-.17c.422-.71 1.34-.963 2.05-.54l1.557.89a1.71 1.71 0 0 1 .63 2.33C16.997 8.349 17.663 9.5 19.29 9.5c.935 0 1.709.765 1.709 1.71v1.583c0 .935-.765 1.709-1.71 1.709-1.627 0-2.293 1.151-1.474 2.564a1.706 1.706 0 0 1-.63 2.33l-1.556.89c-.711.423-1.629.17-2.051-.54l-.1-.17c-.809-1.413-2.14-1.413-2.959 0l-.099.17c-.422.71-1.34.963-2.05.54l-1.557-.89a1.71 1.71 0 0 1-.63-2.33c.819-1.413.153-2.564-1.475-2.564C3.765 14.5 3 13.727 3 12.79" />
    </g>
    <defs>
      <clipPath id="setting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSetting;
